/** the standard RapidMiner orange color taken from rapidminer.com */
export const RAPIDMINER_ORANGE = "#e75424";